import { showErrorMessage } from "./antdMessage";
import i18n from "../i18n";

export const showAppError = (message, t) => {
  const fallbackMessage =
    typeof t === "function"
      ? t("something_went_wrong")
      : i18n.t("something_went_wrong");
  const errorMessage =
    typeof message === "string" && message.trim()
      ? message
      : typeof message === "number"
        ? String(message)
        : fallbackMessage;

  showErrorMessage(errorMessage);
};

export const getApiErrorMessages = (errors) => {
  if (Array.isArray(errors)) {
    return errors.flatMap(getApiErrorMessages);
  }

  if (errors && typeof errors === "object") {
    if (
      typeof errors.success === "boolean" &&
      Object.prototype.hasOwnProperty.call(errors, "message")
    ) {
      return errors.success ? [] : getApiErrorMessages(errors.message);
    }

    return Object.values(errors).flatMap(getApiErrorMessages);
  }

  if (typeof errors === "string" && errors.trim()) {
    return [errors];
  }

  if (typeof errors === "number") {
    return [String(errors)];
  }

  return [];
};

export const handleApiError = (errorOrResponse, t) => {
  const responseData =
    errorOrResponse?.response?.data ||
    errorOrResponse?.response?.response?.data ||
    errorOrResponse?.response?.data?.data ||
    errorOrResponse?.data ||
    {};
  const backendMessage =
    responseData?.data?.error ||
    responseData?.message ||
    responseData?.error ||
    responseData?.data?.message;
  const validationErrors = responseData?.errors || responseData?.data?.errors;
  if (validationErrors) {
    const errorMessages = getApiErrorMessages(validationErrors);

    if (errorMessages.length) {
      errorMessages.forEach((errorMessage) => {
        showAppError(errorMessage, t);
      });
      return;
    }
  }

  const backendMessages = getApiErrorMessages(backendMessage);

  if (backendMessages.length) {
    backendMessages.forEach((errorMessage) => {
      showAppError(errorMessage, t);
    });
    return;
  }

  showAppError(null, t);
};
